import { useEffect, useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import ReactPlayer from "react-player";
import demo from "../../../../../assets/images/pendingIcons/demo.png";
import finish from "../../../../../assets/images/pendingIcons/finish.png";
import jury from "../../../../../assets/images/pendingIcons/jury.png";
import star from "../../../../../assets/images/pendingIcons/star.png";
import start from "../../../../../assets/images/pendingIcons/start.png";
import audionBanner from "../../../../../assets/images/Auditions/image24.png";
import "./StarAuditionDescription.css";
import { TextField } from "@mui/material";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Accordion, Button } from "react-bootstrap";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert";
import { Link, useHistory, useParams } from "react-router-dom";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const StarAuditionDescription = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const [loaded, setLoaded] = useState(false);
  const [title, setTitle] = useState("");
  const [timeBoundery, setTimeBoundery] = useState(new Date());
  const [imagedata, setImagedata] = useState("");
  const [videodata, setVideodata] = useState("");
  const [file, setFile] = useState("");
  const [errorList, setErrorList] = useState([]);

  const [audition, setAudition] = useState({});
  const [auditionInstruction, setAuditionInstruction] = useState({});

  let { audition_id } = useParams();

  const handleImageChange = (file) => {
    setFile(URL.createObjectURL(file[0]));
    setImagedata(file[0]);
  };

  const handleVideoChange = (file) => {

    setVideodata(file[0]);
  };

  const getMyAuditionInstruction = () => {

    axios
      .get(`/api/superstar/audition/liveEditInstructions/${audition_id}`)
      .then((res) => {
        if (res.data.status === 200) {

          setAudition(res.data.audition);
          setAuditionInstruction(res.data.auditionInstruction);
          setTitle(res.data.auditionInstruction?.title);
          setTimeBoundery(res.data.auditionInstruction?.time_boundary);
          setConvertedContent(res.data.auditionInstruction?.description);
          setLoaded(true);
        }
      });
  };

  useEffect(() => {
    getMyAuditionInstruction();
  }, []);

  const [convertedContent, setConvertedContent] = useState(null);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setConvertedContent(currentContentAsHTML);

  };

  const submitEventRound = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", convertedContent);
    formData.append(
      "time_boundary",
      moment(timeBoundery).format("yyyy-MM-DD HH:mm:ss")
    );
    formData.append("banner", imagedata);
    formData.append("video", videodata);

    axios
      .post(
        `/api/superstar/audition/updateAuditionInstruction/${auditionInstruction?.id}`,
        formData
      )
      .then((res) => {
        if (res.data.status === 200) {
          swal("Welcome", res.data.message, "success");

          setAudition(res.data.audition);
          setAuditionInstruction(res.data.auditionInstruction);
        } else if (res.data.status === 422) {
          setErrorList(res.data.validation_errors);
        } else {

        }
      });
  };

  return (
    <>
      {loaded === true ? (
        <>
          {auditionInstruction && auditionInstruction?.status == 0 ? (
            <div className="container-fluid">
              <h2 className="text-white">Request for approval</h2>
              <div className="requestApprovalBottomLine mb-4"></div>

              <div className="mainBorderPending">
                <form encType="multipart/formdata" onSubmit={submitEventRound}>
                  <div className="row ms-5">
                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Instruction Title
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="text"
                          className="form-control Frombtns"
                          placeholder="Enter instruction title"
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                        <span className="text-danger">{errorList.title}</span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Instruction Details
                      </label>
                      <div className="col-sm-8">
                        <CKEditor
                          editor={ClassicEditor}
                          data={convertedContent}

                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                          }}
                        />
                        <span className="text-danger">
                          {errorList.description}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Time boundary
                      </label>
                      <div className="col-sm-8 requestApprovalDateTime">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DateTimePicker
                            renderInput={(props) => <TextField {...props} />}
                            value={timeBoundery}
                            onChange={(getStartTime) => {
                              setTimeBoundery(getStartTime);
                            }}
                          />
                        </LocalizationProvider>
                        <span className="text-danger">
                          {errorList.time_boundary}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-2 col-form-label text-light "
                      >
                        Upload File
                      </label>

                      <div className="col-sm-3 mb-2">
                        <div className="row my-4">
                          <div className="col-md-5 text-white">
                            <img
                              src={file}
                              className="img-fluid avatar-img-src"
                              alt=""
                            />
                          </div>
                          <div className="col-md-7">
                            <input
                              type="file"
                              name="file"
                              id="file"
                              className="inputfile w-25"
                              onChange={(e) =>
                                handleImageChange(e.target.files)
                              }
                            />
                            <label for="file">
                              <i className="fas fa-cloud-upload-alt"></i> Upload
                              Banner
                            </label>
                            <span className="text-danger">
                              {errorList.banner}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <div className="row my-4">
                          <div className="col-md-10">
                            <input
                              type="file"
                              name="file"
                              id="setFile"
                              className="inputfile w-25"
                              onChange={(e) =>
                                handleVideoChange(e.target.files)
                              }
                            />
                            <label for="setFile">
                              <i className="fas fa-cloud-upload-alt"></i> Upload
                              Video
                            </label>
                            <span className="text-danger">
                              {errorList.video}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="photoRelative">
                  <img
                    src={
                      auditionInstruction?.banner
                        ? imageCdnUrl+auditionInstruction?.banner
                        : audionBanner
                    }
                    className="img-fluid audioBanner w-100 my-3"
                    alt=""
                  />
                  <h2 className="registrationDate text-white p-3 fw-bolder">
                    REGISTRATION DATE{" "}
                    {new Date().toLocaleDateString("en-US", {
                      month: "long",
                      day: "2-digit",
                    })}{" "}
                    -{" "}
                    {audition.start_time &&
                      new Date(audition.start_time).toLocaleDateString(
                        "en-US",
                        { month: "long", day: "2-digit" }
                      )}
                  </h2>
                </div>

                <div className="my-3">
                  <ReactPlayer
                    // url="https://youtu.be/dgfTiONcnTc"
                    url={
                      auditionInstruction?.video
                        ? videoCdnUrl+auditionInstruction?.video
                        : "https://youtu.be/dgfTiONcnTc"
                    }
                    playing={false}
                    volume={1}
                    width="100%"
                    controls="true"
                    autoplay
                  />
                </div>
                <div className="row justify-content-start mb-4">
                  <div className="col-md-3 text-left">
                    <button
                      onClick={submitEventRound}
                      className="btn btn-warning mx-4"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {auditionInstruction?.status == 1 ? (
                <div className="container-fluid">
                  <h2 className="text-white">
                    You are already submitted instruction
                  </h2>
                  <div className="requestApprovalBottomLine mb-4"></div>
                </div>
              ) : (
                <></>
              )}
            </>
          )}

          {/* auditionInstruction && auditionInstruction.status == 1 ? :<> <h2 className="text-white">You </h2>
                        <div className="requestApprovalBottomLine mb-4"></div></> : <></> */}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default StarAuditionDescription;
